import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import { accountCollection } from "#root/schema/account";
import { billingInvoiceCollection, type BillingInvoiceDetailItem, getBillingInvoiceItemCollection } from "#root/schema/invoices";
import type { RecordAddResponse } from "#root/utility/remote-data";
import type { ReactNode } from "react";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "./layout";

const cloneCollection = Object.create(billingInvoiceCollection) as typeof billingInvoiceCollection;
cloneCollection.details = async id => {
  const result = await billingInvoiceCollection.details(id);

  if (result) {
    const { row } = result;

    const date = new Date(row.date);
    date.setUTCMonth(date.getUTCMonth() + 1, 1);

    row.date = date.toISOString().replace(/T.*/, "");

    row.state = "Draft";
    row.paid = "0.00";
    delete row.id;
  }
  return result;
};

cloneCollection.addOrUpdate = async (id, opts) => {
  return billingInvoiceCollection.action<RecordAddResponse<BillingInvoiceDetailItem>>(`${id}/clone`, opts);
};

export default function ({ invoiceId }): ReactNode {
  useMemo(() => getBillingInvoiceItemCollection(invoiceId), [invoiceId]);

  const navigate = useNavigate();

  const handleSave = useCallback(
    data => {
      navigate(`/billing/invoice/${data.created}`);
    },
    [navigate],
  );

  return (
    <PageLayout title="Billing - Edit Invoice">
      <section>
        <h2>Edit Invoice</h2>
        <StandardEditor dirty id={invoiceId} collection={cloneCollection} onSave={handleSave}>
          <Fields.Set name="id">
            <Fields.Hidden/>
          </Fields.Set>
          <Fields.Set name="accountId">
            <label>Account</label>
            <Fields.AutoComplete required collection={accountCollection}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="date">
            <label>Invoice Date</label>
            <Fields.DateField/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="paid">
            <label>Amount Paid</label>
            <Fields.Currency/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="segment">
            <label>Segment</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="invoice">
            <label>Invoice</label>
            <Fields.TextArea rows={10}/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
